import { render, staticRenderFns } from "./TicketsChart.vue?vue&type=template&id=2f3cd229&scoped=true&"
import script from "./TicketsChart.vue?vue&type=script&lang=js&"
export * from "./TicketsChart.vue?vue&type=script&lang=js&"
import style0 from "./TicketsChart.vue?vue&type=style&index=0&id=2f3cd229&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f3cd229",
  null
  
)

export default component.exports